import { Component, Input } from '@angular/core';
import { NoteSection } from 'src/app/model/section/note-section';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss']
})
export class NoteComponent {
  @Input() noteSections: NoteSection[] = [];

  constructor() {}
}
